/**
 * ProjectPath - Project-wise status path component
 * Cloned from Lead Path (Path.jsx) - shows project_status instead of lead_status
 * Used inside Project Details section, works per selected project
 */
import React from "react";
import Path from "./Path";

const ProjectPath = ({ values = [], selectedValue = "", completedStatuses = [] }) => {
  const trimmedSelected = String(selectedValue || "").trim();
  const trimmedCompleted = (completedStatuses || []).map(s => String(s || "").trim());

  // Map values to include is_completed flag for Path component
  const processedValues = values.map(val => {
    const trimmedLabel = String(val.label || "").trim();
    return {
      ...val,
      is_completed: trimmedCompleted.includes(trimmedLabel) || trimmedLabel === trimmedSelected
    };
  });

  return <Path values={processedValues} selectedValue={selectedValue} />;
};



export default ProjectPath;
